@if (showFallbackLink) {
    <div class="form-link pb-4px">
        <a href="javascript:void(0)" (click)="login()">Log in with Passkey</a>
    </div>
}
